import type { UserAccess } from '../api/user-access';

export type HolderAccess = 'granted' | 'denied' | 'undetermined';

export function deriveHolderAccess(
  accesses: UserAccess[],
  truncated: boolean,
  holderId: string,
): HolderAccess {
  const grantingAccesses = accesses.filter(
    access => access.scope_type === 'holder'
      && access.scope_id === holderId
      && access.roles.some(role => role.type !== 'automatic'),
  );

  if (grantingAccesses.length > 0) return 'granted';
  return truncated ? 'undetermined' : 'denied';
}
